import React, { createContext, useState, useContext, ReactNode } from 'react';

interface ArticleContextType {
  bookmarkedArticles: number[];
  downloadedArticles: number[];
  toggleBookmark: (id: number) => void;
  toggleDownload: (id: number) => void;
  isBookmarked: (id: number) => boolean;
  isDownloaded: (id: number) => boolean;
}

const ArticleContext = createContext<ArticleContextType | undefined>(undefined);

export const ArticleProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [bookmarkedArticles, setBookmarkedArticles] = useState<number[]>([2]); // Article ID 2 is bookmarked by default
  const [downloadedArticles, setDownloadedArticles] = useState<number[]>([2]); // Article ID 2 is downloaded by default
  // Removed unused variable: const [isLoading, setIsLoading] = useState(false);

  const toggleBookmark = (id: number) => {
    setBookmarkedArticles(prev => 
      prev.includes(id) 
        ? prev.filter(articleId => articleId !== id)
        : [...prev, id]
    );
  };

  const toggleDownload = (id: number) => {
    // Removed: setIsLoading(true);
    // Simulate download process
    setTimeout(() => {
      setDownloadedArticles(prev => 
        prev.includes(id) 
          ? prev.filter(articleId => articleId !== id)
          : [...prev, id]
      );
      // Removed: setIsLoading(false);
    }, 1000);
  };

  const isBookmarked = (id: number) => bookmarkedArticles.includes(id);
  const isDownloaded = (id: number) => downloadedArticles.includes(id);

  return (
    <ArticleContext.Provider value={{ 
      bookmarkedArticles, 
      downloadedArticles, 
      toggleBookmark, 
      toggleDownload,
      isBookmarked,
      isDownloaded
    }}>
      {children}
    </ArticleContext.Provider>
  );
};

export const useArticles = () => {
  const context = useContext(ArticleContext);
  if (context === undefined) {
    throw new Error('useArticles must be used within an ArticleProvider');
  }
  return context;
};